import { DataTransferStatus as n, MediplusStatus as r } from "@my-medication/bff-interfaces-ui/insurances/mediplus";
var u = {
  id: void 0,
  customerId: void 0,
  salutation: void 0,
  firstname: void 0,
  lastname: void 0,
  username: void 0,
  serviceLevel: void 0,
  serviceLevelFilter: void 0,
  isDailymed: void 0,
  accountStatus: void 0,
  communicationSettings: void 0,
  insuranceId: void 0,
  hasMediPlusInsurance: void 0,
  genericAnalysisDoneAt: void 0,
  mediplusStatus: r.deactivated,
  dataTransferStatus: n.initializing,
  insuranceMappingExternalId: void 0,
  insuranceName: void 0,
  sessionInvalid: void 0,
  online: void 0,
  impersonatedUntil: void 0,
  loggedInUntil: void 0,
  lastClickAt: void 0,
  lastNavAt: void 0,
  unviewedMessages: 0,
  email: void 0,
  userDataSource: void 0,
  agreedToTermsAndConditions: void 0,
  profileProgress: void 0,
  noEditMessage: void 0,
  newEmail: void 0,
  locale: void 0,
  source: void 0,
  sessionReady: !1,
  hasApp: !1
}, a = (i) => ({
  setUser: (e) => i((s) => ({ user: {
    ...s.user,
    sessionInvalid: !1,
    id: e.id ?? void 0,
    salutation: e.salutation,
    firstname: e.firstname ?? void 0,
    lastname: e.lastname ?? void 0,
    customerId: e.customerId ?? void 0,
    username: e.username,
    serviceLevel: e.serviceLevel ?? void 0,
    serviceLevelFilter: e.serviceLevelFilter,
    isDailymed: e.isDailymed,
    accountStatus: e.accountStatus ?? void 0,
    profileProgress: e.profileProgress ?? void 0,
    agreedToTermsAndConditions: e.agreedToTermsAndConditions ?? void 0,
    email: e.email,
    communicationSettings: e.communicationSettings,
    insuranceId: e.insuranceId,
    mediplusStatus: e.mediplusStatus || r.deactivated,
    dataTransferStatus: e.dataTransferStatus || n.initializing,
    insuranceMappingExternalId: e.insuranceMappingExternalId,
    hasMediPlusInsurance: e.hasMediPlusInsurance,
    genericAnalysisDoneAt: e.genericAnalysisDoneAt,
    unviewedMessages: e.unviewedMessages,
    insuranceName: e.insuranceHealthName,
    hasApp: e.hasApp
  } })),
  clearUser: () => i((e) => ({ user: {
    ...e.user,
    id: void 0,
    customerId: void 0,
    unviewedMessages: 0,
    username: void 0,
    serviceLevel: void 0
  } })),
  setEmail: (e) => i((s) => ({ user: {
    ...s.user,
    email: e
  } })),
  setOnlineState: (e) => i((s) => ({ user: {
    ...s.user,
    online: e
  } })),
  setLocale: (e) => i((s) => ({ user: {
    ...s.user,
    locale: e
  } })),
  setSource: (e) => i((s) => ({ user: {
    ...s.user,
    source: e
  } })),
  setImpersonated: (e) => i((s) => ({ user: {
    ...s.user,
    impersonatedUntil: e != null ? new Date((/* @__PURE__ */ new Date()).getTime() + e.timeout * 1e3) : void 0
  } })),
  setLoggedInUntil: (e) => i((s) => ({ user: {
    ...s.user,
    loggedInUntil: e != null ? new Date((/* @__PURE__ */ new Date()).getTime() + e.timeout * 1e3) : void 0
  } })),
  setLastClickAt: () => i((e) => ({ user: {
    ...e.user,
    lastClickAt: /* @__PURE__ */ new Date()
  } })),
  setLastNavAt: () => i((e) => ({ user: {
    ...e.user,
    lastNavAt: /* @__PURE__ */ new Date()
  } })),
  setNewEmail: (e) => i((s) => ({ user: {
    ...s.user,
    newEmail: e
  } })),
  setUnviewedMessages: (e) => i((s) => ({ user: {
    ...s.user,
    unviewedMessages: e
  } })),
  setSessionInvalid: (e) => i((s) => s.user.sessionInvalid === e ? s : { user: {
    ...s.user,
    sessionInvalid: e
  } }),
  setUserDataSource: (e) => i((s) => ({ user: {
    ...s.user,
    userDataSource: e
  } })),
  setAccountStatus: (e) => i((s) => ({ user: {
    ...s.user,
    accountStatus: e
  } })),
  setNoEditMessage: (e) => i((s) => ({ user: {
    ...s.user,
    noEditMessage: e
  } })),
  setCommunicationSettings: (e) => i((s) => ({ user: {
    ...s.user,
    communicationSettings: e
  } })),
  setSessionReady: (e) => i((s) => ({ user: {
    ...s.user,
    sessionReady: e
  } })),
  setProfileProgress: (e) => i((s) => ({ user: {
    ...s.user,
    profileProgress: e
  } })),
  setGenericAnalysisDoneAt: (e) => i((s) => ({ user: {
    ...s.user,
    genericAnalysisDoneAt: e
  } }))
});
export {
  a as createUserActions,
  u as initialUserState
};

//# sourceMappingURL=user.action.js.map